module.exports = __webpack_public_path__ + "static/media/150.3770c714.png";